import React from "react";
import reactCSS from "reactcss";
import { ChromePicker as SketchPicker, CompactPicker } from "react-color";
import './ColorPicker.css'

export class ColorPicker extends React.Component {
  state = {
    displayColorPicker: false,
    color: this.props.value
  };

  static defaultProps = {
    value: {
      r: "241",
      g: "112",
      b: "19",
      a: "1"
    }
  };

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false });
  };

  handleChange = color => {
    this.setState({ color: color.rgb });
    this.props.onChange(color);
  };

  UNSAFE_componentWillReceiveProps = nextProps => {
    if (nextProps.value !== this.state.value) {
      this.setState({ color: nextProps.value });
    }
  };

  render() {
    const styles = reactCSS({
      default: {
        color: {
          width: "36px",
          height: "28px",
          borderRadius: "2px",
          background: `rgba(${this.state.color.r}, ${this.state.color.g}, ${
            this.state.color.b
          }, ${this.state.color.a})`
        },
        swatch: {
          padding: "2px",
          background: "#fff",
          borderRadius: "1px",
          boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
          display: "inline-block",
          cursor: "pointer"
          //   marginLeft: 10
        },
        popover: {
          position: "absolute",
          zIndex: 2,
          top: 10,
          right: 10
        },
        cover: {
          position: "fixed",
          top: "0px",
          right: "0px",
          bottom: "0px",
          left: "0px"
        }
      }
    });

    const compactAStyles = reactCSS({
      default: {
        Compact: {
          background: "black"
        }
      }
    });
    return (
      <div className="color-picker">
        <CompactPicker
          styles={compactAStyles}
          color={this.state.color}
          onChange={this.handleChange}
        />
        <div style={styles.swatch} onClick={this.handleClick}>
          <div style={styles.color} />
        </div>
        {this.state.displayColorPicker ? (
          <div style={styles.popover}>
            <div style={styles.cover} onClick={this.handleClose} />
            <SketchPicker
              color={this.state.color}
              onChange={this.handleChange}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default ColorPicker;
